import type { AuthUserRoleEnum } from '@/generated/graphql/types';

export const getTalentBaseUrl = () => {
  return process.env.APP_ENV === 'production'
    ? 'https://hr.acsendo.com'
    : 'https://pruebas.acsendo.com';
};

export const getRedirectToTalentUrl = (options: {
  centralizedId: string;
  userRole: AuthUserRoleEnum;
}) => {
  const { centralizedId, userRole } = options;
  return `/api/v5/rest/auth/learning/auth/cross/talent/?centralized_organization_id=${centralizedId}&user_role=${userRole}&next_url=${getTalentBaseUrl()}`;
};
